// Styles
import { hydroBlue } from '../../../common/styles/colors';
import { NotificationBoxV2Wrapper } from './NotificationBoxV2.styles';

type NotificationBoxV2Props = {
  type: 'M1' | 'M2' | 'M8' | 'M9' | 'A1' | 'A2' | 'C1' | 'C2' | 'X1' | 'L1';
  boxText: string;
  buttonText?: string;
  onClick?: Function;
  showButton: boolean;
};

const defaultProps = {};

export const NotificationBoxV2 = (props: NotificationBoxV2Props) => {
  const onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    props.onClick?.(event);
  };

  return (
    <NotificationBoxV2Wrapper className='d-flex flex-column mb-1'>
      <>
        <div className='notificationV2-box'>
          <div className='d-flex'>
            <p className='mt-auto mb-auto notification-message-row'>
              <div className='notification-badge'>{props.type}</div>
              <div className='notification-message'>
                {props.boxText}
                <a href={''} style={{ color: hydroBlue }} onClick={onClick}>
                  <span className='notification-button'>{props.buttonText}</span>
                </a>
              </div>
            </p>
          </div>
        </div>
      </>
    </NotificationBoxV2Wrapper>
  );
};

NotificationBoxV2.defaultProps = defaultProps;
